import type { AuditLogEntry } from "src/api/client-api/auditLog/auditLogSchemas";

export const AUDIT_LOG_CSV_COLUMNS = [
    "occurredAt",
    "action",
    "actorType",
    "actorLabel",
    "entityType",
    "entityLabel",
    "recipientLabel",
    "rootType",
    "rootLabel",
    "ip",
    "requestId",
    "id",
] as const satisfies readonly (keyof AuditLogEntry)[];

const FORMULA_TRIGGER = /^[\t ]*[=+\-@]/;

const neutralizeFormula = (text: string): string => (FORMULA_TRIGGER.test(text) ? `'${text}` : text);

const escapeCell = (value: unknown): string => {
    if (value === null || value === undefined) {
        return "";
    }

    const text = neutralizeFormula(String(value));

    return /[",;\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const auditLogToCsv = (entries: AuditLogEntry[]): string =>
    [
        AUDIT_LOG_CSV_COLUMNS.join(","),
        ...entries.map((entry) => AUDIT_LOG_CSV_COLUMNS.map((column) => escapeCell(entry[column])).join(",")),
    ].join("\n");

export const auditLogCsvFilename = (now: Date, count: number): string =>
    `journal-audit-${now.toISOString().slice(0, 19).replace(/[:T]/g, "-")}-${count}.csv`;
